import ReactMarkdown from 'react-markdown';
import { getImageCacheUrl } from 'common/utilities';
import { css } from 'linaria';
import { breakpointLargeHandset } from 'common/constants';
import PropTypes from 'prop-types';
const authorBioStyle = "a16lmb8x";
export function AuthorBio({
  name,
  bio,
  imageUrl
}) {
  const shouldShow = bio?.length;
  const image = imageUrl.length ? getImageCacheUrl(imageUrl, {
    width: 200,
    height: 200
  }) : false;
  return shouldShow ? <cite className={authorBioStyle}>
      {image ? <img src={image} alt="" /> : null}
      <div className="bio">
        <h4>{name}</h4>
        <ReactMarkdown>{bio}</ReactMarkdown>
      </div>
    </cite> : null;
}
AuthorBio.propTypes = {
  /**
   * Name of the author to display as the header
   */
  name: PropTypes.string,
  /**
   * Biographical details about the author
   */
  bio: PropTypes.string,
  /**
   * Optional image to include along side the biogrpahical details
   */
  imageUrl: PropTypes.string
};

require("./author-bio.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./author-bio.js");